import { render } from "./RestoreModal.vue?vue&type=template&id=1e5dbc6a&scoped=true"
import script from "./RestoreModal.vue?vue&type=script&lang=js"
export * from "./RestoreModal.vue?vue&type=script&lang=js"

import "./RestoreModal.vue?vue&type=style&index=0&id=1e5dbc6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5dbc6a"]])

export default __exports__